'use client';

import dynamic from 'next/dynamic';

const RainbowButtonEmbeds = dynamic(() => import('./index'));

export default RainbowButtonEmbeds;
